module.exports = __webpack_public_path__ + "img/slide12.37aa5ffa.png";